import React from 'react'
import "./Footer.scss"

const  Footer : React.FC = () =>  {
  return (
    <div className='footer'>
     <div>
        Movie App
      </div>
      <div>
        @2023, Movie, Inc. or its affiliates
      </div>
      </div>
  )
}

export default Footer